import React, { useState, useEffect, useMemo } from "react";
import { toast } from "react-toastify";

const UserDetails = () => {
  const [modulesData, setModulesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const Auth = localStorage.getItem("authToken");
    const userRole = localStorage.getItem("UserRole");

  useEffect(() => {
    fetchModulesData();
  }, []);
  const fetchModulesData = async () => {
    try {
      const response = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/admin/modules/view", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
      });

      
      
      const result = await response.json();
      if (!result.success) throw new Error("Failed to fetch form data");
      setModulesData(result.data || []);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  
  const filteredModulesData = useMemo(() => {
    const today = new Date();
    let filtered = modulesData.filter((u) => {
      const nameMatch = u.moduleName?.toLowerCase().includes(search.toLowerCase()) ;
      

      return nameMatch ;
    });

    
    

    return filtered;
  }, [modulesData, search]);

  // Pagination Method
  const totalPages = Math.ceil(filteredModulesData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentModulesData = filteredModulesData.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

 
  return (
    <div className="Task-Details-Container">
      <h2 className="text-xl font-semibold mb-4">Modules</h2>
      <div className="flex justify-between items-center mb-4">
        <div className="user-heading">
                  </div>
      
        <div className="flex justify-end flex-wrap gap-4 mb-4">
          <input
            type="text"
            placeholder="Search by module name..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            className="px-4 py-2 border rounded"
          />
          

          
        </div>
      </div>

      
      <table className="w-full text-sm border user-table">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">#</th>
            <th className="px-4 py-2 text-left">Module Name</th>
            <th className="px-4 py-2 text-left">Sub Modules Name</th>
          </tr>
        </thead>
        <tbody>
          {currentModulesData.length > 0 ? (
            currentModulesData.map((f, index) => (
              <tr key={f.id || index} className="border-t">
                <td className="px-4 py-2">{startIndex + index + 1}</td>
                <td className="px-4 py-2"><div className="flex items-center space-x-2">{f.moduleName || "N/A"}</div></td>
                <td className="px-4 py-2">{f.sub_modules?.length > 0
                    ? f.sub_modules.map((sub) => sub.subModuleName).join(", ")
                    : "N/A"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4 text-gray-500">
                No form data found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      
      <div className="flex justify-center mt-4 gap-2 items-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      
      
    </div>
  );
};

export default UserDetails;


const formatDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return isNaN(date.getTime()) ? "" : date.toLocaleString();
};
